import { Button, Select, Table } from 'antd';
import { Badge } from 'flowbite-react';
import React, { useEffect, useState } from 'react';
import { Link, useLoaderData, useLocation, useNavigate, useParams } from 'react-router-dom';
import Pagination from '../../globalComponents/Pagination';
import Axios from '../utils/axios';





const columns = [
  {
    title: 'Date',
    dataIndex: 'date',
    key: 'date',
    className: 'whitespace-nowrap font-medium text-[#189aa0] dark:text-white',
    render: (_, record) => <span>{`${new Date(record.date).toLocaleDateString()}`}</span>
  },
  {
    title: 'Number',
    dataIndex: 'number',
    key: 'number',
    className: 'whitespace-nowrap font-medium text-[#189aa0] dark:text-white'
  },
  {
    title: 'Journal',
    dataIndex: 'journal',
    key: 'journalz',
    className: 'whitespace-nowrap font-medium text-[#189aa0] dark:text-white'
  },
  {
    title: 'Payment Method',
    dataIndex: 'payment_method',
    key: 'payment_method',
    className: 'whitespace-nowrap font-medium text-[#189aa0] dark:text-white'
  },
  {
    title: 'Customer',
    dataIndex: 'contact',
    key: 'contact',
    className: 'whitespace-nowrap font-medium text-[#189aa0] dark:text-white'
  },
  {
    title: 'Amount (GHc)',
    dataIndex: 'amount',
    key: 'amount',
    className: 'whitespace-nowrap font-medium text-[#189aa0] dark:text-white',
    render: (_, record) => <span>{(record.amount.$numberDecimal * 1).toFixed(2)}</span>
  },
  {
    title: 'Status',
    dataIndex: 'status',
    key: 'status',
    className: 'whitespace-nowrap font-medium text-[#189aa0] dark:text-white',
    render: (_, record) => <Badge className={record.status === 'Draft' ? "text-red-950 bg-red-100 w-max" : record.status === 'Posted' && "text-green-950 bg-green-100 w-max"}>{record.status}</Badge>
  },
]

const vendorcolumns = [
  {
    title: 'Date',
    dataIndex: 'date',
    key: 'date',
    className: 'whitespace-nowrap font-medium text-[#189aa0] dark:text-white',
    render: (_, record) => <span>{`${new Date(record.date).toLocaleDateString()}`}</span>
  },
  {
    title: 'Number',
    dataIndex: 'number',
    key: 'number',
    className: 'whitespace-nowrap font-medium text-[#189aa0] dark:text-white'
  },
  {
    title: 'Journal',
    dataIndex: 'journal',
    key: 'journalz',
    className: 'whitespace-nowrap font-medium text-[#189aa0] dark:text-white'
  },
  {
    title: 'Payment Method',
    dataIndex: 'payment_method',
    key: 'payment_method',
    className: 'whitespace-nowrap font-medium text-[#189aa0] dark:text-white'
  },
  {
    title: 'Vendor',
    dataIndex: 'contact',
    key: 'contact',
    className: 'whitespace-nowrap font-medium text-[#189aa0] dark:text-white'
  },
  {
    title: 'Amount (GHc)',
    dataIndex: 'amount',
    key: 'amount',
    className: 'whitespace-nowrap font-medium text-[#189aa0] dark:text-white',
    render: (_, record) => <span>{(record.amount.$numberDecimal * 1).toFixed(2)}</span>
  },
  {
    title: 'Status',
    dataIndex: 'status',
    key: 'status',
    className: 'whitespace-nowrap font-medium text-[#189aa0] dark:text-white',
    render: (_, record) => <Badge className={record.status === 'Draft' ? "text-red-950 bg-red-100 w-max" : record.status === 'Posted' && "text-green-950 bg-green-100 w-max"}>{record.status}</Badge>
  },
]





const Payments = () => {
  const loader = useLoaderData();
  const navigate = useNavigate();
  const params = useParams();
  const partner_type = params.partner_type;
  const location = useLocation();
  const state = location.state;
  const [searchItems, setSearchItems] = useState(loader);
  const [paginations, setPaginations] = useState({pageSize: 100, page: 1});

  
  const onRow = (record, rowIndex) => {
    return {
      onClick: () => navigate('/accounting/payments/'+record.number.replaceAll("/", '-'), { state: {...state}})
    };
  }

  async function fetchUserList(pagination_) {

    return Axios(`payments/all/${params.partner_type}/search?pagination=${JSON.stringify(pagination_)}`)
      .then((response) => response.data)
      .then((res) => {
        setSearchItems(res);
      });
  }


  useEffect(() => {
    // const totalPages = Math.ceil(paginations.total / paginations.pageSize);
    // if (paginations.page < 1) setPaginations({...paginations, page: 1});
    // if (paginations.page > totalPages) setPaginations({...paginations, page: totalPages});
    const offset = (paginations.page - 1) * paginations.pageSize;
    let pagination_ = {offset, pageSize: paginations.pageSize};
    // let filters = {search: {by: searchBy, values: search, filters: selectedFilters}};
    fetchUserList(pagination_);
  },[paginations])

  return (
    <div>
      <div className='flex justify-between mx-4'>
        <h3 className='font-bold'>Payments</h3>
        <div className='bg-white dark:bg-gray-900'>
          {/* <Input addonBefore={<MdFilterAlt />}  defaultValue="mysite" /> */}

          <Select
            mode='multiple'
            size={'middle'}
            placeholder='Filter'
            // defaultValue={['a10', 'c12']}
            // onChange={handleChange}
            className='w-96'
            options={[]}
          />
        </div>
      </div>
      <div className='columns-2 mx-4 my-2'>
        <div className='column'>
          <Button className='' size={'sm'}>
            <Link to={'/accounting/payments/new'}  state={{...state}} className='w-full'>
              New
            </Link>
          </Button>
        </div>
        <div className='dark:bg-gray-900 column'>
          <div className='flex justify-end'>
            <Pagination paginations={paginations} total={searchItems.totalRows} setPaginations={setPaginations}/>
          </div>
        </div>
      </div>
      <Table
        onRow={onRow}
        rowClassName={'hover:cursor-pointer'}
        dataSource={searchItems.all}
        columns={partner_type === 'customer' ? columns : vendorcolumns}
        scroll={{ x: 1500 }}
        pagination={false}
      />
    
    </div>
  )
}

export default Payments;